import { Row } from "@/libraries/wpl/foundations/src";
import { Breadcrumbs } from "@/patterns/breadcrumbs/src/breadcrumbs";
import { useAgileHubPageTreeData } from "@/templates/agile-hub/src/use-agile-hub-page-tree-data";
import { getProgressivePathSegments } from "@/utils/breadcrumb-helper/breadcrumb-helper";
import { useLocation } from "@/utils/location-provider";

export const usePathSegmentNames = (paths: string[]) => {
    const agileTree = useAgileHubPageTreeData();
    const names = paths.map((path) => {
        if (path === "/agile") {
            return { name: "Agile", path: "/agile" };
        }
        const node = agileTree.find((obj) => path.includes(obj.urlSlug));
        if (node) {
            if (path === node.urlSlug) {
                return { name: node.name, path: node.urlSlug };
            } else {
                const childNode =
                    node.children &&
                    node.children.find((obj) => path === obj.urlSlug);
                if (childNode) {
                    return { name: childNode.name, path: childNode.urlSlug };
                }
            }
        }
        return { name: "", path: "" };
    });
    return names;
};

export const AgileBreadcrumbs = () => {
    const location = useLocation();
    const { pathname } = location;
    const segmentPaths: string[] = getProgressivePathSegments(pathname);
    const segmentObjs = usePathSegmentNames(segmentPaths);

    return (
        <Row layout="12" alignItems="top">
            <Breadcrumbs links={segmentObjs} />
        </Row>
    );
};
